//---------------- IMPORTAÇÕES ----------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";

//---------------- FUNÇÃO PARA BUSCAR LEADS QUENTES ----------------//
// Espelha loadLeadsService.js — POST contra a mesma base axios (baseURL = /api).
// Endpoint final: /api/leads/quentes (cookie JWT).
export default async function loadLeadsQuentesService(limit, offset, busca, periodo, comprou, excluirTags) {
  try {
    const response = await api.post("/leads/quentes", {
      limit,
      offset,
      busca: busca || "",
      periodo: periodo || 30,
      comprou: comprou === undefined ? null : comprou,
      excluir_tags: Array.isArray(excluirTags) ? excluirTags : [],
    });
    return response;
  } catch (error) {
    toast.error("Erro ao carregar leads quentes");
    return null;
  }
}
